import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-nobuses',
    templateUrl: './nobuses.component.html',
    styleUrls: ['./nobuses.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NobusesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
